function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-delete_svg__a",
  d: "M8.5 7.44L15.243.696a.75.75 0 011.06 1.06L9.561 8.5l6.742 6.743a.75.75 0 01-1.06 1.06L8.5 9.561l-6.743 6.742a.75.75 0 01-1.06-1.06L7.439 8.5.697 1.757a.75.75 0 011.06-1.06L8.5 7.439z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3.5 3.5)"
}, React.createElement("mask", {
  id: "icon-delete_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#icon-delete_svg__a"
})), React.createElement("g", {
  fill: "#646a70",
  mask: "url(#icon-delete_svg__b)"
}, React.createElement("path", {
  d: "M-3.5-3.5h24v24h-24z"
})));

var SvgIconDelete = function SvgIconDelete(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-delete.91af5223.svg";
export { SvgIconDelete as ReactComponent };